<div class="vh-100 d-flex justify-content-center align-items-center login-container" *ngIf="!loginDisplay">
  <div class="col-sm-6 col-10">
    <div class="p-4 login-card bg-white rounded-5">
      <div class="mb-3 text-center">
        <img src="/assets/images/login-logo.png" alt="Login logo">
      </div>
      <!--locally build successfully-->
      <div class="action-buttons-wrapper px-4">

        <button mat-raised-button class="g-btn g-primary-btn mb-2 w-100" *ngIf="!loginDisplay" (click)="LoginSSO()">SSO Login </button>
      </div>



    </div>
  </div>
</div>